import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-left: 50px;
  flex-grow: 1;
`;
